import { useApiClient } from "@hostingbv/lib/src/api";
import { Paragraph } from "@hostingbv/lib/src/components/Paragraph";
import { FC, useState } from "react";
import { config } from "../config";
import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { Customer } from "@hostingbv/lib/src/api/common/models/Customer";
import { Contact } from "@hostingbv/lib/src/api/common/models/Contact";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const RevokeCustomerContactAccessModal: FC<{ customer: Customer, contact: Contact }> = props => {
  const { partnerClient } = useApiClient(config)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const [error, setError] = useState('')

  // ModalFooter refreshes and closes once this resolves, so wait until the login is actually disabled.
  const done = async () => {
    setError('')
    const result = await partnerClient.revokeCustomerContactAccess(props.customer.id, props.contact.id)
    if (!result.success) {
      setError(result.error)
      throw new Error(result.error)
    }
    const deployment = await awaitNextDeploymentFinished(result.data.id)
    if (deployment?.status === "failed") {
      // @ts-expect-error output is untyped
      setError(deployment.output?.message ?? 'Could not revoke login access')
      throw new Error('deployment failed')
    }
  }

  return <>
    <div className={"space-y-4 flex-1"}>
      <h2 className={"text-base font-medium"}>Are you sure?</h2>
      <Paragraph>The user (<strong>{props.contact.email}</strong>) will no longer be able to access their resources.</Paragraph>
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
      <ModalFooter text={"Revoke access"} onSubmit={done} />
    </div>
  </>
}

